import { render, staticRenderFns } from "./modifyInfoDc.vue?vue&type=template&id=5f21df5a"
import script from "./modifyInfoDc.vue?vue&type=script&lang=js"
export * from "./modifyInfoDc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports